module.exports = __webpack_public_path__ + "img/renwu.6f552a67.jpg";